import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import '../../css/base.css';
import $ from 'jquery';
import { setPage, setActivity, setSection, setFormFactor } from '../../store/AppSlice';

const MainMenu = () => {
  const dispatch = useDispatch();

  const appstate = useSelector((state) => state.appState);

  useEffect(() => {
    window.addEventListener("resize", handleScreenResize);
    handleScreenResize();

    return () => {
      window.removeEventListener("resize", handleScreenResize);
    }
  }, []);

  const handleScreenResize = () => {

    const mediaQuery = window.matchMedia('(min-width: 768px)');
    if (mediaQuery.matches) {
      $(".menu-container").css("display", "block");
      dispatch(setFormFactor("TABLET"));
    } else {
      dispatch(setFormFactor("MOBILE"));
    }

    // Maintain the aspect ratio of the google maps and streetview
    var div = $('.street-maps-image');
    var width = div.width();
    div.css('height', width*0.66);
  }

  const selectPage = (event, data) => {
    var allMenuItems = document.getElementsByClassName("menu-btn");

    Array.from(allMenuItems).forEach((item) => {
      item.style.backgroundColor = "#61a5c2";
      item.style.color = "white";
    });      

    var menu = document.getElementById(event.target.id);
    menu.style.backgroundColor = "#468faf";
    menu.style.color = "#325288";

    dispatch(setSection("COTTAGE"));
    dispatch(setPage(data));
    dispatch(setActivity(""));

    var allMenuItems = document.getElementsByClassName("left-menu-btn");

    Array.from(allMenuItems).forEach((item) => {
      item.style.backgroundColor = "#61a5c2";
      item.style.color = "white";
    });      

    var initialMenu = document.getElementById("activities-local-walks-menu-item");
    if (initialMenu) {
      initialMenu.style.backgroundColor = "#468faf";
      initialMenu.style.color = "#325288";  
    }
  }

  const closeMenu = () => {
    $(".menu-container").css("display", "block");
  }

  const isWelcome = () => {
    if (appstate.mode === "WELCOME") {
      return (
          <div className="col-3 col-md-2 col-xl menu-col">
            <div id="menu-btn-welcome" className="menu-btn" onClick={(event) => selectPage(event, "WELCOME")}>
                Welcome
            </div>
          </div>
      )
    }
  }

  const isYourStay = () => {
    if (appstate.mode === "WELCOME") {
      return (
          <div className="col-3 col-md-2 col-xl menu-col">
            <div id="menu-btn-your-stay" className="menu-btn" onClick={(event) => selectPage(event, "YOUR_STAY")}>
                Your Stay
            </div>
          </div>
      )
    }
  }

  const getHomePageName = () => {
    if (appstate.mode === "WELCOME") {
      return "Cottage"
    } else {
      return "Home"
    }
  }

  return (
    <div id="main-menu" className="menu-container">
    <div className="row">
        {isWelcome()}
        {isYourStay()}
        <div className="col-3 col-md-2 col-xl menu-col">
          <div id="menu-btn-home" className="menu-btn" onClick={(event) => selectPage(event, "HOME")}>
            {getHomePageName()}
          </div>
        </div>
        <div className="col-3 col-md-2 col-xl menu-col">
          <div id="menu-btn-booking" className="menu-btn" onClick={(event) => selectPage(event, "BOOKING")}>
              Booking
          </div>
        </div>
        <div className="col-3 col-md-2 col-xl menu-col">
          <div id="menu-btn-gallery" className="menu-btn" onClick={(event) => selectPage(event, "GALLERY")}>
              Gallery
          </div>
        </div>
        <div className="col-3 col-md-2 col-xl menu-col">
          <div id="menu-btn-location" className="menu-btn"  onClick={(event) => selectPage(event, "LOCATION")}>
              Location
          </div>
        </div>
        <div className="col-3 col-md-2 col-xl menu-col">
          <div id="menu-btn-activities" className="menu-btn" onClick={(event) => selectPage(event, "ACTIVITIES")}>
              Activities
          </div>
        </div>
        <div className="col-3 col-md-2 col-xl menu-col">
          <div id="menu-btn-eating-out" className="menu-btn" onClick={(event) => selectPage(event, "EATING_OUT")}>
              Dining
          </div>
        </div>
        <div className="col-3 col-md-2 col-xl menu-col">
          <div id="menu-btn-contact" className="menu-btn" onClick={(event) => selectPage(event, "REVIEWS")}>
              Reviews
          </div>
        </div>
      </div>
  </div>
  );
}

export default MainMenu;